import moment from "moment";
import { useEffect, useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { getViewerDocumentTitleByDocType } from "../../../constants/statusToDocMap/statusToDocMap";
import { JCodeDocuments } from "../../../data-model/medicalPaOrdersModel";
import { ModalId } from "../../../enums/modalId";
import WarningIcon from "../../../svg/warningIcon";
import CustomCheckBox from "../../customCheckBox/customCheckBox";

interface TriggerRpaWithDocListModalProps {
  onClose: () => void;
  onCancel: () => void;
  onTriggerRpa: (selectedDocuments: JCodeDocuments[]) => void;
  loading: boolean;
  orderId: string;
  docList: JCodeDocuments[];
}
const TriggerRpaWithDocListModal = (props: TriggerRpaWithDocListModalProps) => {
  const handleTriggerRpa = () => {
    props.onTriggerRpa(selectedDocuments);
  };

  const [allDocs, setAllDocs] = useState<JCodeDocuments[]>([]);
  const [selectedDocuments, setSelectedDocuments] = useState<JCodeDocuments[]>(
    [],
  );
  useEffect(() => {
    setAllDocs(props.docList);
  }, [props.docList]);

  return (
    <Modal
      dialogId={ModalId.TRIGGER_RPA_WITH_DOC_LIST_MODAL}
      title="Trigger RPA"
      onSave={handleTriggerRpa}
      onClose={props.onClose}
      onCancel={props.onCancel}
      saveButtonText={props.loading ? "Triggering..." : "Trigger RPA"}
      cancelText="Cancel"
      disableSave={
        props.loading || allDocs.length === 0 || selectedDocuments.length === 0
      }
    >
      <div className="trigger-rpa-modal-container flex flex-col gap-4">
        <div className="documents-section">
          {allDocs.length === 0 ? (
            <NoDocumentsToUpload />
          ) : (
            <>
              <div className="mb-3 text-small text-primaryGray-1">
                Select documents to be uploaded
              </div>
              <div className="documents-list flex flex-col gap-3">
                {allDocs.map((doc, index) => (
                  <div
                    className="custom-checkbox-with-timestamp flex items-center justify-between"
                    key={
                      doc.doc_path +
                      "_" +
                      doc.doc_type +
                      "_" +
                      doc.doc_title +
                      "_" +
                      index
                    }
                  >
                    <CustomCheckBox
                      id={
                        doc.doc_path +
                        "_" +
                        doc.doc_type +
                        "_" +
                        doc.doc_title +
                        "_" +
                        index
                      }
                      label={
                        doc.doc_title +
                        " (" +
                        getViewerDocumentTitleByDocType(doc.doc_type ?? "") +
                        ")"
                      }
                      className="!mt-[3px] !text-small"
                      isChecked={selectedDocuments.includes(doc)}
                      onCheckBoxValueChange={(value) => {
                        if (value.value) {
                          setSelectedDocuments([...selectedDocuments, doc]);
                        } else {
                          setSelectedDocuments((prev) =>
                            prev.filter((d) => d.doc_path !== doc.doc_path),
                          );
                        }
                      }}
                    />
                    <div className="mt-[6px] text-xs italic text-primaryGray-5">
                      Last Uploaded on{" "}
                      {moment(doc.doc_upload_date).format("MM/DD/YYYY")}
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 rounded-md bg-secondaryYellow-11 p-3">
                <p className="text-sm italic text-primaryGray-5">
                  If NAR is based on auth grid, skip PDF
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

const NoDocumentsToUpload = () => {
  return (
    <div className="no-documents-to-upload flex flex-col items-center justify-center gap-2">
      <WarningIcon height="24" width="24" />
      <div className="text-sm italic text-primaryGray-5">
        No relevant documents found to be uploaded.
      </div>
      <div className="text-sm italic text-primaryGray-5">
        Please upload the documents first.
      </div>
    </div>
  );
};

export default TriggerRpaWithDocListModal;
